import { UseFieldArrayReturn } from "react-hook-form/dist/types";
import IBaseDTO from "src/Interfaces/baseDTO";
import { completePermissionType } from "../Permissions/interface";

export interface ITablesRelated{
    statementLineId?: number;
    subsidiaryId?: number;
}

// Interfaces 
export interface IRefIndicatorModal {
    actionButtonAdd: (onClose?:(indicator?:IIndicatorForm)=>void, tablesRelated?: ITablesRelated) => void;
    actionButtonChange: (id:number,duplicate:boolean,onClose?:(indicator?:IIndicatorForm)=>void) => void;
}
export interface IIndicatorForm {
    indicator:IIqtbc001;
    goal:IIqtbc002;
    competitiveness?:IIqtbc002;
    compromise?:IIqtbc002;
    fields:IIqtbc002[];
    metrics:IIqtbc004[];
    permissions:IIqtbc005[];
    useCompromise:boolean;
    useCompetitiveness:boolean;
    tags:number[];
    selectedGoalField:string;
    iqc003Id:number;
    statementLineId?: number;
    subsidiaryId?: number;
}

export interface IIqtbc001 extends IBaseDTO{
    iqc001Id : number;
    iqc001Codigo : string;
    iqc001Descricao : string;
    iqc001Qtdeperant : number
    iqc001Tipoperiodo : number;
    iqc001Formaaval : EvaluationForm;
    iqc001Taa001Id?: number;
    iqc001Taa002Id?: number;
    iqc001Efa005Id : number;
    iqc001Fontedados : string;
    iqc001Metodo : string;
    iqc001Descobjetivo : string;
    iqc001Observacao : string;
    iqc001Iqb003Id?: number;
    iqc001Validade : Date;
    iqc001Taa005Id : number;
    iqc001Nivel :IndicatorLevel;
    iqc001Taa006Id : string;
    iqc001Periodofechado : ClosedPeriods;
    iqc001Tendencia :  boolean;
    iqc001Ocultarformaaval : boolean;
    iqc001Calcularacum : boolean;
    iqc001Mostrarvalor : ValueIndicator;
    iqc001Taa009Id?: number;
    iqc001Verificafca : boolean;
    iqc001Escalamin?: number;
    iqc001Escalamax?: number;
    iqc001Corgrafico : GraphicColors;
    iqc001Compgrafico?: GraphicComp;
    iqc001Roteixoesq : string;
    iqc001Roteixodir : string;
    iqc001Escalamindir?: number;
    iqc001Escalamaxdir?: number;
    iqc001Labelvalores?: GraphicOrientation;
    iqc001PaletaCores:number;
    iqc001DecimaisPainel: number;
    iqc001Linkexterno: string;
    iqc001Ordemmetas: string;
}

export interface IIqtbc002{
    id:string;
    iqc002Id :number;
    iqc002Iqb001Id:string;
    iqc002Mostragrafico :boolean;
    iqc002Tipografico :GraphicType;
    iqc002Acumular :boolean;
    iqc002Tpgrafacum :GraphicType;
    iqc002Tipoacum :AccumulateType;
    iqc002Compararmeta :string;
    iqc002Ordem ?:number;
    iqc002Metadefault?:number;
    iqc002Utilizarcamposbase:boolean;
    iqc002Dividendo?:number;
    iqc002Divisor?:number;
    iqc002Mostrartabela :boolean;
    iqc002Eixoygrafico?:number;
    iqc002Mostrarvalor :boolean;
    label?:string;
    fieldType?:number;
    description?:string;
    decimalPlaces?:number;
    showConfig?:boolean;
    showGraphics?:boolean;
    iqc002CorGrafico?:string;
}

export interface IIqtbc004{
    id:string;
    iqc004Id:number;
    iqc004Cor:string;
    iqc004Valorini:number;
    iqc004Valorfim:number;
}

export interface IIqtbc005{
    id:string;
    iqc005Id:number;
    iqc005Efa004Id?:number;
    efa004Descricao?:string,
    iqc005Efa005Id?:number;
    efa005Nome?:string;
    iqc005Permissao:completePermissionType;
}

export interface ITab{
    indicator:IIqtbc001;
    tags?:number[];
    errors:any;
    control:any;
    register:any;
    hidden?: boolean;
}

export interface IGeneralTab extends ITab{
    setValue: any;
    isDuplicate: boolean; 
}

export interface ISimpleFormTab extends ITab{
    goal:IIqtbc002;
    setValue: any;
    isDuplicate: boolean;
}

export interface IGoalsTab extends Omit<ITab,"indicator"|"tags">{
    isAdd:boolean;
    goal:IIqtbc002;
    competitiveness?:IIqtbc002;
    compromise?:IIqtbc002;
    fields:Array<{value:string,label:string}>;
    setValue:any;
    selectedIndicator: number;
    orderGoals: string;
}

export interface IMetricsTab extends Omit<ITab,"indicator"|"tags">{
    defaultMetricId?:string;
    metrics:IIqtbc004[];
    useArrayControls:UseFieldArrayReturn;
    clearErrors:any;
    setValue:any;
}

export interface IPermissionsTab extends Omit<ITab,"indicator"|"tags"|"errors">{
    permissions:IIqtbc005[];
    clearErrors:any;
    unregister:any;
    errors:any;
}

export interface IFieldsTab extends Omit<ITab,"indicator"|"tags">{
    indicatorsFields:IIqtbc002[];
    simpleField:boolean;
    selectFieldtoGoal:string;
    clearErrors:any;
    setValue:any;
    selectedIndicator: number;
}

// Enums
export enum IndicatorLevel {
    STRATEGIC = "E",
    TATIC="T",
    OPERATIONAL="O"
}

export enum EvaluationForm {
    TO_DOWN="0",
    TO_UP = "1"
}

export enum ValueIndicator {
    PERCENTUAL="1",
    ABSOLUTE = "2"
}

export enum GraphicComp {
    SIDE_BY_SIDE="1",
    STACK = "2"
}

export enum GraphicColors {
    METRICS="1",
    SUBTITLE = "2"
}

export enum GraphicOrientation {
    HORIZONTAL="1",
    VERTICAL = "2"
}

export enum ClosedPeriods {
    CLOSED_ONLY = "S",
    CLOSED_AND_STARTED = "N",
    ALL_PERIODS = "A"
}

export enum GraphicType {
    LINE ="1",
    COLUMN = "2",
    AREA = "3"
}

export enum AccumulateType {
    AVERAGE = "M",
    SUM = "S",
    LAST_VALUE = "U",
    FORMULA = "F"
}

export enum AxisY {
    LEFT = "1",
    RIGTH = "2"
}

export enum GoalType {
    GOAL = "S",
    COMPETITIVENESS = "C",
    COMPROMISE = "O",
    NO_GOAL = "N"
}

// Bases
export const baseIqtbc002 = {
	iqc002Mostragrafico:true,
	iqc002Acumular:true,
	iqc002Utilizarcamposbase:false,
	iqc002Mostrarvalor:true,
	iqc002Tipografico:GraphicType.LINE,
	iqc002Tpgrafacum:GraphicType.LINE,
	iqc002Tipoacum:AccumulateType.AVERAGE,
	iqc002CorGrafico:"",
	iqc002Mostrartabela:true
} as IIqtbc002;

